import type { DeckDef } from "@/decks/types";

// Deck comercial base enfocado en abastecimiento. No es de un cliente: se usa tal cual en
// reuniones y se duplica desde el admin para adaptarlo (textos, notas, orden, slides
// ocultas). Por eso cada slide se entiende sola. Mover una slide = mover su línea.
// Ocultarla = hidden: true. El copy vive en messages/es.json bajo deck.abastecimiento.*.
export const abastecimientoDeck: DeckDef = {
  id: "abastecimiento",
  // Por ahora se abre solo con el link directo: no aparece en el manifest de la landing.
  listed: false,
  languages: ["es"],
  slides: [
    {
      id: "portada",
      load: () => import("./slides/PortadaSlide"),
    },
    {
      id: "quienes-somos",
      load: () => import("./slides/QuienesSomosSlide"),
    },
    {
      id: "dilema",
      load: () => import("./slides/DilemaSlide"),
    },
    {
      id: "quiebres",
      load: () => import("./slides/QuiebresSlide"),
    },
    {
      id: "capital",
      load: () => import("./slides/CapitalSlide"),
    },
    {
      id: "erp-pregunta",
      load: () => import("./slides/ErpPreguntaSlide"),
    },
    {
      id: "erp-limite",
      load: () => import("./slides/ErpLimiteSlide"),
    },
    {
      id: "sota",
      load: () => import("./slides/SotaSlide"),
    },
    {
      id: "producto",
      load: () => import("./slides/ProductoSlide"),
    },
    {
      id: "pilares",
      load: () => import("./slides/PilaresSlide"),
    },
    {
      id: "cadena",
      load: () => import("./slides/CadenaSlide"),
    },
    {
      // Las dos slides siguientes van juntas: el diagrama por capas y, sobre el mismo
      // diagrama en gris, las otras áreas que usan el forecast.
      id: "como-funciona",
      load: () => import("./slides/ComoFuncionaSlide"),
    },
    {
      id: "pronostico",
      load: () => import("./slides/PronosticoSlide"),
    },
    {
      id: "forecast",
      load: () => import("./slides/ForecastSlide"),
    },
    {
      id: "variables",
      load: () => import("./slides/VariablesSlide"),
    },
    {
      id: "demo",
      load: () => import("./slides/DemoSlide"),
    },
    {
      // Oculta por defecto: los outputs se muestran en la demo. Se activa desde el admin.
      id: "parametros",
      load: () => import("./slides/ParametrosSlide"),
      hidden: true,
    },
    {
      // Oculta por defecto, igual que el output anterior.
      id: "redistribucion",
      load: () => import("./slides/RedistribucionSlide"),
      hidden: true,
    },
    {
      id: "funcionalidades",
      load: () => import("./slides/FuncionalidadesSlide"),
    },
    {
      id: "impacto",
      load: () => import("./slides/ImpactoSlide"),
    },
    {
      id: "como-trabajamos",
      load: () => import("./slides/ComoTrabajamosSlide"),
    },
    {
      // Oculta por defecto. Se activa desde el admin si la reunión entra en el piloto.
      id: "medicion",
      load: () => import("./slides/MedicionSlide"),
      hidden: true,
    },
    {
      id: "cierre",
      load: () => import("./slides/CierreSlide"),
    },
    {
      id: "contacto",
      load: () => import("./slides/ContactoSlide"),
    },
  ],
};
